import { ca } from '@cian/analytics';

export const trackNewbuildingBrokerBannerButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click_sopr',
    label: 'independent_banner',
  });
};
